import ClickOutside from '@shared/plugins/close-outside-click'
import filters from '@shared/plugins/filters'
import formatters from '@shared/plugins/formatters'
import prune from '@shared/plugins/prune'
import safeRoutePush from '@shared/plugins/safe-push'
import rootMethods from '@shared/plugins/root-methods'
import handleResourceFetchError from '@shared/plugins/handle-resource-fetch-error'
import ThCommonResourceUtils from '@shared/plugins/common-resource-utils'
import ThCurrencyFormatter from '@shared/plugins/currency-formatter'
import ThNumberFormatter from '@shared/plugins/number-formatter'
import ThCurrencyInputV2 from '@shared/components/inputs/currency-input'
import ThCurrencySelect from '@shared/components/currency-select'
import ThDatatable from '@shared/components/datatable'
import ThDateFormatter from '@shared/plugins/date-formatter'
import ThDeepClone from '@shared/plugins/deep-clone'
import ThImage from '@shared/components/image'
import ThImageUploadV2 from '@shared/components/image-upload-v2'
import ThInputTitle from '@shared/components/input-title'
import ThLogException from '@shared/plugins/log-exception'
import ThNumberInputV2 from '@shared/components/inputs/number-input'
import ThPageWrapper from '@shared/components/tillhub/page-wrapper.vue'
import ThPagination from '@shared/components/pagination'
import ThPopover from '@shared/components/popover'
import ThDrawer from '@shared/components/drawer'
import ThQuickView from '@shared/components/tillhub/quick-view.vue'
import ThRemoteSearchSelect from '@shared/components/remote-search-select'
import ThResourceSelect from '@shared/components/resource-select'
import ThStaffNameFormatter from '@shared/plugins/staff-name-formatter'
import ThTabsFormWrapper from '@shared/components/tabs-form-wrapper'
import ThWrapper from '@shared/components/wrapper'
import ThModalPlugin from '@shared/plugins/th-modal'
import ThModal from '@shared/components/modal'
import ThAskToDeletePlugin from '@shared/plugins/th-ask-to-delete'
import ThBreadcrumbItem from '@shared/components/breadcrumbs/breadcrumb-item.vue'
import { Calendar, DatePicker, setupCalendar } from 'v-calendar'
import VueUniversalModal from 'vue-universal-modal'
import Debug from '@shared/plugins/debug'
import Posthog from '@shared/plugins/posthog'
import CookieScript from '@shared/plugins/cookie-script'
// TODO: slow loading of the icons, why?
import InlineSvg from 'vue-inline-svg'

export function registerDependencies(app, { i18n }) {
  app.component('ThCurrencyInput', ThCurrencyInputV2)
  app.component('ThCurrencySelect', ThCurrencySelect)
  app.component('ThDatatable', ThDatatable)
  app.component('ThImage', ThImage)
  app.component('ThImageUploadV2', ThImageUploadV2)
  app.component('ThInputTitle', ThInputTitle)
  app.component('ThNumberInput', ThNumberInputV2)
  app.component('ThPageWrapper', ThPageWrapper)
  app.component('ThPagination', ThPagination)
  app.component('ThPopover', ThPopover)
  app.component('ThDrawer', ThDrawer)
  app.component('ThQuickView', ThQuickView)
  app.component('ThRemoteSearchSelect', ThRemoteSearchSelect)
  app.component('ThResourceSelect', ThResourceSelect)
  app.component('ThTabsFormWrapper', ThTabsFormWrapper)
  app.component('ThWrapper', ThWrapper)
  app.component('ThModal', ThModal)
  app.component('ThBreadcrumbItem', ThBreadcrumbItem)
  app.component('Svgicon', InlineSvg)

  app.use(setupCalendar)
  app.component('VCalendar', Calendar)
  app.component('VDatePicker', DatePicker)

  app.use(ClickOutside)
  app.use(filters)
  app.use(formatters)
  app.use(prune)
  app.use(safeRoutePush)
  app.use(rootMethods)
  app.use(CookieScript)
  app.use(handleResourceFetchError)
  app.use(ThCommonResourceUtils)
  app.use(ThCurrencyFormatter, { i18n })
  app.use(ThNumberFormatter, { i18n })
  app.use(ThDateFormatter)
  app.use(ThDeepClone)
  app.use(ThLogException)
  app.use(ThModalPlugin)
  app.use(ThAskToDeletePlugin)
  app.use(ThStaffNameFormatter)
  app.use(VueUniversalModal, {
    teleportTarget: '#th-modals'
  })
  app.use(Debug)
  app.use(Posthog)
  //app.use(Meta)
  //app.use(VueSVGIcon)
}
